import { putResolve, put, takeEvery } from 'redux-saga/effects';
import * as actions from '../../actions/utility-actions';
import { PagedResultRequest } from '../../models/utilities/requests';
import { ToastMessage } from "../../models/utilities/toast-message";
import { Mapper } from '../../utils/mapper';

/**
 * Fetch, process, and update store for paged result
 * @param action The redux action
 */
export function* getPagedResultWorker(action: IReduxAction) {

    const request = action.payload as PagedResultRequest;
    if(!request.searchParams) {
        return;
    }

    yield put(actions.showLoading());

    try{

        const rawResponse = yield putResolve(actions.fetch(request.searchParams.toUrl(), 'GET'));
        const parsedResponse = Mapper.deserializeApiList(request.type, rawResponse, request.searchParams.paginationInfo);

        yield put({
            type: request.successAction,
            payload: parsedResponse
        });

    }
    catch (err) {

        console.error(err);
        if(err && err.message){
            yield put(actions.showToastNotification(new ToastMessage(err.message, "error")));
        }
        
        yield put({
            type: request.failAction
        });

    }

    yield put(actions.hideLoading());
}

/**
 * Watch for messages to make paged get request
 */
export function* getPagedResultWatcher() {
    yield takeEvery(actions.UTILITY_GET_PAGED_RESULT, getPagedResultWorker);
}
